import { Typography } from '@mui/material'
import ChatConversationLayout from '@/components/Chat/ChatConversationLayout'
import ChatMessagesScrollRegion from '@/components/Chat/ChatMessagesScrollRegion'
import { ChatControllerProvider } from '@/features/chat/ChatControllerContext'
import { ThreadPreviewReadOnlyContext } from '@/features/chat/threadPreviewReadOnly'
import ThreadsSearchDialogPreviewRows from './ThreadsSearchDialogPreviewRows'
import styles from './ThreadsSectionAllThreadsDialog.module.scss'

export default function ThreadsSearchDialogPreviewThread({ messages, loading, threadId }) {
  if (loading) {
    return <Typography component="p" className={styles.previewEmpty}>Loading preview…</Typography>
  }
  if (!messages.length) {
    return (
      <Typography component="p" className={styles.previewEmpty}>
        No messages in this thread yet.
      </Typography>
    )
  }
  return (
    <ThreadPreviewReadOnlyContext.Provider value={true}>
      <ChatControllerProvider value={{ send: () => {} }}>
        <div className={styles.previewScroll}>
          <div className={styles.previewFrame}>
            <ChatConversationLayout className={styles.previewLayout}>
              <ChatMessagesScrollRegion className={styles.previewTranscript}>
                <div inert>
                  <ThreadsSearchDialogPreviewRows messages={messages} threadId={threadId} />
                </div>
              </ChatMessagesScrollRegion>
            </ChatConversationLayout>
          </div>
        </div>
      </ChatControllerProvider>
    </ThreadPreviewReadOnlyContext.Provider>
  )
}
